function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 10H7C6.448 10 6 10.448 6 11V12V14V15C6 15.552 6.448 16 7 16H15C15.552 16 16 15.552 16 15V11C16 10.448 15.552 10 15 10Z",
  fill: "#002A95"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 12H2V6H5V4H2V1C2 0.448 1.552 0 1 0C0.448 0 0 0.448 0 1V13C0 13.553 0.448 14 1 14H5V12Z",
  fill: "#002A95"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15 2H7C6.448 2 6 2.448 6 3V4V6V7C6 7.552 6.448 8 7 8H15C15.552 8 16 7.552 16 7V3C16 2.448 15.552 2 15 2Z",
  fill: "#002A95"
});

var SvgForms = function SvgForms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Forms.5241476e.svg";
export { ForwardRef as ReactComponent };